
const setCSSVariables = () => {
  const root = document.documentElement;
  root.style.setProperty('--primary-color', '#4CAF50');
  root.style.setProperty('--secondary-color', '#FF5722');
  root.style.setProperty('--primary', '#2575fc');
  root.style.setProperty('--secondary', '#ff4081');
  root.style.setProperty('--background', '#f4f4f4');
  root.style.setProperty('--textSecondary', '#333');
  root.style.setProperty('--success', '#28a745');
  root.style.setProperty('--error', '#dc3545');
  root.style.setProperty('--warning', '#FFC000');
  root.style.setProperty('--info', '#17a2b8');
  root.style.setProperty('--ctaOne', '#628A4C')
  root.style.setProperty('--ctaTwo', '#c4e477')
  root.style.setProperty('--ctaThree', '#87b444')
  root.style.setProperty('--ctaFour', '#76993D')
  root.style.setProperty('--ctaFive', '#AFBE6C')
  root.style.setProperty('--ctaSix', '#006666')
};
export default setCSSVariables;
